import { render, staticRenderFns } from "./sysManagement.vue?vue&type=template&id=71ad0366&scoped=true&"
import script from "./sysManagement.vue?vue&type=script&lang=js&"
export * from "./sysManagement.vue?vue&type=script&lang=js&"
import style0 from "./sysManagement.vue?vue&type=style&index=0&id=71ad0366&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad0366",
  null
  
)

export default component.exports